export const FINANCIAL_TYPES_VALUES = {
  hipoteca: 1,
  personal: 2,
  anticipo: 3,
  descuento: 4,
  credito: 5,
  avales: 6
}

export const FINANCINGS_WITH_SHARE = [ 
  FINANCIAL_TYPES_VALUES.hipoteca,
  FINANCIAL_TYPES_VALUES.personal,
  FINANCIAL_TYPES_VALUES.anticipo,
  FINANCIAL_TYPES_VALUES.avales
]

export const HOW_RETURN_VALUES = {
  cajaFutura: 1,
  financiacionFlujo: 2,
  flujoProbable: 3,
  // flujoPosible: 4,
  otros: 5
}

export const LEGAL_FORM_VALUES = {
  SL: 1,
  SA: 2,
  FUNDATION: 3,
  ASSOCIATION: 4,
  FREELANCE: 5,
  COOPERATIVE: 6,
  CIVIL: 7,
  COMMUNITIES_GOODS: 8,
  AIE: 9,
  SAT: 10,
  CONGREGATIONS: 11,
  UTE: 12,
  OTHERS: 13
}

export const SIZES_VALUES = {
  SMALL: 1,
  MEDIUM: 2,
  BIG: 3
}

export const PROJECTIONS_VALUES = {
  HIGHER: 1,
  SIMILAR: 2,
  LOWER: 3
}
